import { Component, OnDestroy, OnInit } from "@angular/core";
import { StatusListener } from "../../../status-listener";
import { AppStatus } from "../../../@models/app-status";
import { ContactFun } from "../../../../shared/model/locations/contact.fun";
import { PeripheralStatus } from "../../../../shared-gen/Payment/PeripheralStatus";
import { PeripheralType } from "../../../../shared-gen/Payment/Peripherals/PeripheralType";
import { AppService } from "../../../services/app.service";
import { Door } from "../../../../shared-gen/Model/Devices/Door";
import { DoorState } from "../../../../shared-gen/Model/Devices/DoorState";
import { EntityHeaderFun } from "../../../../shared/model/utils/entity-header.fun";
import { Router } from "@angular/router";
import { DataUpdateStatusFun } from "../../../../shared/updates/data/data-update-status.fun";
import { MemoryStickLicenseState } from "../../../../shared-gen/Device/Status/MemoryStickLicenseState";
import { nullSafe, sleep } from "../../../../shared/utils/core-utils";
import { ExportTimeSpan } from "../../../../shared-gen/Devices/WebApi/Api/ExportTimeSpan";

@Component({
	selector: "app-tur-configuration-panel",
	templateUrl: "./tur-configuration-panel.component.html",
	styleUrls: ["./tur-configuration-panel.component.scss"]
})
export class TurConfigurationPanelComponent extends StatusListener implements OnInit, OnDestroy {

	dataUpdate = DataUpdateStatusFun.createNew();

	deviceHeader = EntityHeaderFun.createNew();
	locationID = "";
	locationName = "";
	contact = "";
	terminalID = "";
	softwareVersion = "";

	isOnline = false;
	peripherals: { [key in PeripheralType]: PeripheralStatus };
	doors: { [key in Door]?: DoorState } = {};
	theme = "";

	memoryStickLicenseState = MemoryStickLicenseState.None;
	excelTransactionsExportMessage = "";
	isHaccpProblemSet = false;

	constructor(protected app: AppService, private router: Router) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		const dev = status.deviceStatus;

		this.dataUpdate = dev.DataUpdate || DataUpdateStatusFun.createNew();

		this.deviceHeader = dev.DeviceHeader;
		this.locationID = dev.DeviceInfo.LocationID;
		this.locationName = dev.Location.Name;
		this.contact = ContactFun.toText(dev.Location.Contact);
		this.terminalID = dev.DeviceInfo.TerminalID;
		this.softwareVersion = dev.SoftwareVersion;
		this.isOnline = dev.IsOnline;
		this.peripherals = dev.PaymentStatus.Peripherals;
		this.doors = dev.Doors;
		this.theme = status.deviceStatus.UIConfig.AppTheme;

		this.memoryStickLicenseState = nullSafe(() =>
			status.deviceStatus.MemorySticks.LicenseState) || MemoryStickLicenseState.None;
		this.isHaccpProblemSet = nullSafe(() =>
			status.deviceStatus.MachineStatus.Problems.some(it => it.ID == "HACCP"));
	}

	async checkOnline() {
		const response = await this.app.api.systemApi.pingBackend();
		console.log("Backend ping: " + response);
	}

	reloadApp() {
		window.location.reload();
	}

	async startDataUpdate() {
		await this.app.api.deviceApi.startDataUpdate();
		const updatePage = this.app.getStatus().theme.updatePage;
		if (updatePage)
			this.router.navigate([updatePage]);
	}

	enhanceMemoryStickMessage(text: string): string {
		text = text.replace("\\n", " ");
		text = text.replace("%deviceid%", this.deviceHeader.ID);
		return text;
	}

	async exportExcelTransactions(timeSpan: ExportTimeSpan) {
		try {
			this.excelTransactionsExportMessage = this.translate("🌐General.PleaseWait");
			await this.app.api.exportApi.exportExcelTransactions(timeSpan);
			this.excelTransactionsExportMessage = this.translate("🌐MachineScreen.TransactionsSaved");
		}
		catch (ex) {
			this.excelTransactionsExportMessage = this.translate("🌐General.Error");
		}
		await sleep(5000);
		this.excelTransactionsExportMessage = "";
	}

	async deleteHaccpProblem() {
		await this.app.api.machineApi.setProblem("HACCP", false);
	}
}
